module.exports = __webpack_public_path__ + "static/media/image-3.2d54c3ea.png";